import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { QrcodeLightboxService } from '@targx/services/qrcode-lightbox/qrcode-lightbox.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, CommonModule, MatIconModule, MatButtonModule],
})
export class AppComponent {
    qrcodeLightboxService = inject(QrcodeLightboxService);

    /**
     * Constructor
     */
    constructor() {}

    closeLightbox(): void {
        this.qrcodeLightboxService.close();
    }
}
